import { useRef } from 'react';

import SignUpForm from '@/ui/components/SignUpForm';
import { clickLPConversionButton } from '@/utils/analytics/log-event';

import Cast from './components/Cast';
import ConversionBanner from './components/ConversionBanner';
import FAQuestions from './components/FAQuestions';
import FirstView from './components/FirstView';
import Footer from './components/Footer';
import Header from './components/Header';
import LessonFlow from './components/LessonFlow';
import Promises from './components/Promises';
import Recommended from './components/Recommended';
import SectionTitle from './components/SectionTitle';
import Services from './components/Services';
import SignUpHeader from './components/SignUpHeader';

export type LandingPageProps = {
  price: string;
  priceWithTax: string;
  discountedPriceWithTax: string;
  priceWithBankTransfer: {
    year: string;
    halfYear: string;
  };
  totalVideos: string;
};

type ServerProps = {
  isDiscounted: boolean | null;
};

const Component: React.FC<ServerProps> = ({ isDiscounted }) => {
  const lpProps: LandingPageProps = {
    price: '980',
    priceWithTax: '1,078',
    discountedPriceWithTax: '539',
    totalVideos: '4,200',
    priceWithBankTransfer: {
      year: '11,642',
      halfYear: '6,468',
    },
  };
  const scrollPositionRef = useRef<null | HTMLDivElement>(null);
  const scrollToForm = () =>
    scrollPositionRef.current?.scrollIntoView({ behavior: 'smooth' });
  return (
    <>
      <Header scrollToForm={scrollToForm} />

      <div className="flex flex-col items-center px-2 pt-10 md:px-4 md:pt-20">
        <div className="flex w-full flex-col items-center md:max-w-[920px]">
          <FirstView lpProps={lpProps} scrollToForm={scrollToForm} />
          <SectionTitle title="Shakehandsの4つの特長" />
          <Promises lpProps={lpProps} />
          <ConversionBanner
            lpProps={lpProps}
            isDiscounted={isDiscounted}
            onButtonClick={() => {
              scrollToForm();
              clickLPConversionButton('conversion_banner_top');
            }}
          />
          <SectionTitle title="Shakehandsだけの強み" />
          <Services lpProps={lpProps} />
          <SectionTitle title="動画レッスンの流れ" />
          <LessonFlow />
          <ConversionBanner
            lpProps={lpProps}
            isDiscounted={isDiscounted}
            onButtonClick={() => {
              scrollToForm();
              clickLPConversionButton('conversion_banner_bottom');
            }}
          />
          <SectionTitle title="Shakehandsはこんな方におすすめ" />
          <Recommended />
          <SectionTitle title="指導経験豊富なコーチ陣・出演者" />
          <Cast />
          <SectionTitle title="よくある質問" />
          <FAQuestions lpProps={lpProps} />
          <div className="h-6" ref={scrollPositionRef} />
          <div className="my-10 w-full max-w-screen-sm">
            <SignUpHeader />
            <SignUpForm lpName="base" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Component;
